import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Storage } from '@ionic/storage-angular';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private storage_user: Storage | null = null

  constructor(private storage: Storage, private router: Router) {}

  async canActivate(): Promise<boolean> {
    const storage = await this.storage.create()
    this.storage_user = storage
    return this.storage_user?.get(environment.localStorage).then((res) => {
      if (res?.id) {
        return true
      } else {
        this.router.navigate(['login'])
        return false
      }
    })
  }
}
